export const API_URL: string = 'https://rickandmortyapi.com/graphql';
export const CARDS_PER_ROW: number = 5;
export const ACTIVE_CARD_CLASS: string = 'card__active';
